import { render } from "./Index.vue?vue&type=template&id=26b33f2c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WebHost\\htdocs\\helpdesk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__